import { AppProps } from 'next/app'
import { useEffect, useRef } from 'react'
import fromEntries from 'object.fromentries'
import { AnimatePresence, useScroll } from 'framer-motion'

import 'styles/reset.css'
import 'styles/fonts.css'
import 'styles/layout.css'
import 'styles/nav.css'

import 'intersection-observer'
if ( !Object.fromEntries ) fromEntries.shim()

type Props = AppProps & {
	// Workaround from https://github.com/vercel/next.js/issues/8592
	err: any
}

export default function Ray({ Component, pageProps, router, err }: Props ) {
	const loaded = useRef( false )
	useEffect( () => {
		if ( loaded.current === false ) loaded.current = true
	}, [ router.route ] )

	const { scrollY } = useScroll()
	useEffect( () => (
		scrollY.onChange( () => {
			if ( scrollY.getPrevious() < 600 && scrollY.get() >= 600 ) {
				// Restart the nav fade in animation when the user was scrolled down
				loaded.current = false
			} else if ( scrollY.getPrevious() >= 600 && scrollY.get() < 600 ) {
				// Cancel when he scrolls back up to use the main nav
				loaded.current = true
			}
		})
	) )

	useEffect( () => {
		// eslint-disable-next-line no-console
		console?.log( '👨‍💻  Dev: Rijk van Wel\n👉  https://rijk.io' )
	}, [] )

	const key = ( router.route === '/products/[collection]'
		? router.route // don't do a page transition when switching collection
		: router.asPath
	)

	return (
		<AnimatePresence mode="wait">
			<Component key={key} loaded={loaded.current} {...pageProps} err={err} />
		</AnimatePresence>
	)
}
